import * as Sentry from '@sentry/react'

import type { UserInfo } from '@/client/types.gen'
import { isSentrySendPiiEnabled, isSentryUserFeedbackAvailable } from '@/services/sentry'

function buildFeedbackMessage(releaseVersion: string, description: string): string {
	const trimmed = description.trim()
	return [
		'## feedback_type: feature_request',
		`## release_version: ${releaseVersion}`,
		`## description: ${trimmed}`,
	].join('\n')
}

function resolveFeedbackUserIdentity(user?: UserInfo | null): { name?: string; email?: string } {
	if (!isSentrySendPiiEnabled() || !user) {
		return {}
	}

	const name = [user.firstname, user.lastname].filter(Boolean).join(' ') || undefined
	const email = user.email ?? undefined
	return { name, email }
}

export function submitWhatsNewFeatureRequestFeedback(
	releaseVersion: string,
	description: string,
	user?: UserInfo | null
): string | undefined {
	if (!isSentryUserFeedbackAvailable()) {
		return undefined
	}

	const trimmed = description.trim()
	if (!trimmed) {
		return undefined
	}

	const { name, email } = resolveFeedbackUserIdentity(user)

	return Sentry.captureFeedback({
		message: buildFeedbackMessage(releaseVersion, trimmed),
		...(name ? { name } : {}),
		...(email ? { email } : {}),
		url: window.location.href,
		source: 'whats-new-feature-request',
		tags: {
			feedback_source: 'whats-new-feature-request',
			feedback_type: 'feature_request',
			release_version: releaseVersion,
		},
	})
}
